(() => {
  const THRESHOLD = 24;
  const hasTransparentHeader = document.body && (
    document.body.classList.contains('aa-home')
    || document.body.classList.contains('aa-transparent-header-page')
  );
  if (!hasTransparentHeader) return;

  const storeHeader = document.querySelector('store-header.header');
  if (!storeHeader) return;
  const headerWrapper = document.querySelector('.cc-header');
  const announcementBar = document.querySelector('.cc-announcement');

  const desktopMenuButton = storeHeader.querySelector('.openHeaderMenuBtn');
  const desktopMenuPanel = storeHeader.querySelector('.header-menu-desktop');
  const mobileDisclosure = storeHeader.querySelector('.main-menu__disclosure');

  let rafId = 0;

  const isDesktopMenuOpen = () => {
    return Boolean(
      (desktopMenuButton && desktopMenuButton.classList.contains('is-open'))
      || (desktopMenuPanel && desktopMenuPanel.classList.contains('is-open'))
    );
  };

  const isMobileMenuOpen = () => {
    return Boolean(
      mobileDisclosure
      && (mobileDisclosure.classList.contains('is-open') || mobileDisclosure.open === true)
      && window.matchMedia('(max-width: 1023px)').matches
    );
  };

  const update = () => {
    rafId = 0;
    const scrollTop = window.scrollY || document.documentElement.scrollTop || 0;
    const atTop = scrollTop <= THRESHOLD;
    const menuOpen = isDesktopMenuOpen() || isMobileMenuOpen();
    const useTransparent = atTop && !menuOpen;
    const announcementOffset = announcementBar ? announcementBar.offsetHeight : 0;

    document.documentElement.style.setProperty('--aa-announcement-offset', `${announcementOffset}px`);

    storeHeader.classList.toggle('aa-home-header-top', useTransparent);
    if (headerWrapper) {
      headerWrapper.classList.toggle('aa-home-header-top', useTransparent);
    }
  };

  const queueUpdate = () => {
    if (rafId) return;
    rafId = requestAnimationFrame(update);
  };

  const observer = new MutationObserver(queueUpdate);

  if (desktopMenuButton) {
    observer.observe(desktopMenuButton, { attributes: true, attributeFilter: ['class'] });
  }

  if (desktopMenuPanel) {
    observer.observe(desktopMenuPanel, { attributes: true, attributeFilter: ['class'] });
  }

  if (mobileDisclosure) {
    observer.observe(mobileDisclosure, { attributes: true, attributeFilter: ['class', 'open'] });
  }

  window.addEventListener('scroll', queueUpdate, { passive: true });
  window.addEventListener('resize', queueUpdate, { passive: true });
  document.addEventListener('click', queueUpdate, { passive: true });

  update();
})();
